import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import { useContext } from 'react';
import { AccordionContext, Accordion as BootstrapAccordion, Button } from 'react-bootstrap';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import styled from 'styled-components';

import { min } from '../utils/breakpoints';

const StyledButton = styled(Button)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none !important;
  color: ${(props) => props.theme.colors.black} !important;

  .fa-chevron-down {
    transition: transform 0.2s linear;
    -webkit-transition: transform 0.2s linear;
    -moz-transition: transform 0.2s linear;
    -o-transition: transform 0.2s linear;
  }

  &.expand .fa-chevron-down {
    transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -o-transform: rotate(180deg);
  }

  .accordion-arrow {
    margin-left: 8px;
  }

  ${min.sm} {
    .accordion-arrow {
      margin-left: 12px;
    }
  }
`;

const CustomToggle = ({ eventKey, children }) => {
  const currentEventKey = useContext(AccordionContext); // <-- Will update every time the eventKey changes.
  const toggleOnClick = useAccordionToggle(eventKey);
  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    <StyledButton
      variant="link"
      className={cx({
        expand: isCurrentEventKey,
      })}
      block
      onClick={toggleOnClick}
    >
      {children}
    </StyledButton>
  );
};

const StyledAccordion = styled(BootstrapAccordion)`
  > div {
    margin-top: 12px;

    &:first-child {
      margin-top: 0;
    }
  }
`;

const StyledAccordionItem = styled.div`
  border: 1px solid ${(props) => props.theme.colors.light};
  border-radius: 8px;
  padding: 8px 12px;
`;

const StyledAccordionToggle = styled(CustomToggle)`
  border: none;
  padding: 0;
  width: 100%;
  text-align: left;
  background-color: ${(props) => props.theme.colors.white};
  cursor: pointer;
  font-size: 14px;

  ${min.sm} {
    font-size: 16px;
  }
`;

const StyledAccordionCollapse = styled(BootstrapAccordion.Collapse)`
  margin-top: 10px;
  padding-left: 9px;
  padding-right: 9px;
`;

const Accordion = ({ data, defaultActiveKey = '' }) => (
  <StyledAccordion defaultActiveKey={defaultActiveKey}>
    {data?.map((item, index) => (
      <StyledAccordionItem key={index}>
        <StyledAccordionToggle variant="link" eventKey={index.toString()} callback={() => {}}>
          <div className="text-left">{item?.title}</div>
          <FontAwesomeIcon className="accordion-arrow" icon={faChevronDown} />
        </StyledAccordionToggle>
        <StyledAccordionCollapse eventKey={index.toString()}>{item?.content}</StyledAccordionCollapse>
      </StyledAccordionItem>
    ))}
  </StyledAccordion>
);

export default Accordion;
